const handleClassNames = (block) => {
    if (!block || !block.name) {
        return block;
    }
    const { attributes } = block;
    const className = [];
    const baseClassName = block.name.split("/");
    const be = block.name.slice(-1) === "s" ? "are" : "is";
    if (baseClassName[0] === "core") {
        className.push("wp-block-" + baseClassName[1]);
    }
    else {
        className.push("wp-block-" + baseClassName.join("-"));
    }
    if (attributes.align === "full") {
        className.push("alignfull");
    }
    if (["left", "center", "right"].includes(attributes.align)) {
        className.push(`has-text-align-${attributes.align}`);
    }
    if (attributes.verticalAlignment) {
        className.push(be + "-vertically-aligned-" + attributes.verticalAlignment);
    }
    if (attributes.layout?.verticalAlignment) {
        className.push("vertically-aligned-" + attributes.layout.verticalAlignment);
    }
    if (attributes.layout?.type) {
        className.push(attributes.layout.type);
    }
    if (attributes.layout?.orientation) {
        className.push("is-" + attributes.layout.orientation);
    }
    if (attributes.layout?.justifyContent) {
        className.push("is-content-justification-" + attributes.layout?.justifyContent);
    }
    if (attributes.isSection) {
        className.push("is-section");
    }
    if (attributes.overlayColor && attributes.overlayColor.length) {
        className.push("has-" + attributes.overlayColor + "-background-color");
    }
    if (attributes.backgroundColor && attributes.backgroundColor.length) {
        className.push("has-" + attributes.backgroundColor + "-background-color");
    }
    if (attributes.hasImage) {
        className.push("has-image");
    }
    if (attributes.className) {
        className.push(attributes.className);
    }
    /* work recursively */
    const newClassName = [...new Set(className)].join(" ");
    if (block.innerBlocks && block.innerBlocks.length) {
        return {
            ...block,
            attributes: {
                ...attributes,
                className: newClassName,
            },
            innerBlocks: block.innerBlocks.map((e) => handleClassNames(e)),
        };
    }
    return {
        ...block,
        attributes: {
            ...attributes,
            className: newClassName,
        },
    };
};
export default handleClassNames;
